// import React, { useState, useEffect } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../../Components/NoRecordFound";
// import { useNavigate } from "react-router-dom";
// import {
//   deleteComboProductServ,
//   exportComboProductServ,
//   getComboProductServ,
//   updateComboProductServ,
// } from "../../../services/comboProduct.services";
// import { triggerFileDownload } from "../../../utils/fileDownload";

// function ComboProductList() {
//   const navigate = useNavigate();
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     status: "",
//     pageNo: 1,
//     pageCount: 10,
//     sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const handleGetComboProductFunc = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       let response = await getComboProductServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };
//   const staticsArr = [
//     {
//       title: "Total Combo Packs",
//       count: statics?.totalCount,
//       bgColor: "#6777EF",
//     },
//     {
//       title: "Active Combo Packs",
//       count: statics?.activeCount,
//       bgColor: "#63ED7A",
//     },
//     {
//       title: "Inactive Combo Packs",
//       count: statics?.inactiveCount,
//       bgColor: "#FFA426",
//     },
//   ];
//   useEffect(() => {
//     handleGetComboProductFunc();
//   }, [payload]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [editFormData, setEditFormData] = useState({
//     name: "",
//     productHeroImage: "",
//     status: "",
//     _id: "",
//   });
//   const updateComboProductFunc = async () => {
//     try {
//       let response = await updateComboProductServ({
//         id: editFormData?._id,
//         status: editFormData?.status,
//       });
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setEditFormData({
//           name: "",
//           productHeroImage: "",
//           status: "",
//           _id: "",
//         });
//         handleGetComboProductFunc();
//       }
//     } catch (error) {
//       toast.error("Internal Server Error");
//     }
//   };
//   const handleDeleteComboProductFunc = async (id) => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete this product?"
//     );
//     if (confirmed) {
//       try {
//         let response = await deleteComboProductServ(id);
//         if (response?.data?.statusCode == "200") {
//           toast.success(response?.data?.message);
//           handleGetComboProductFunc();
//         }
//       } catch (error) {
//         toast.error("Internal Server Error");
//       }
//     }
//   };

//   const [totalPages, setTotalPages] = useState(1);

//   useEffect(() => {
//     if (statics?.totalCount && payload.pageCount) {
//       const pages = Math.ceil(statics.totalCount / payload.pageCount);
//       setTotalPages(pages);
//     }
//   }, [statics, payload.pageCount]);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setPayload({ ...payload, pageNo: newPage });
//     }
//   };

//   const handleDownload = async () => {
//     try {
//       const response = await exportComboProductServ(payload);
//       triggerFileDownload(response.data, "comboList.pdf");
//     } catch (err) {
//       toast.error("Download failed");
//     }
//   };

//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Product Management" selectedItem="Combo Packs" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 topActionForm">
//             <div className="col-lg-2 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">Combo Pack</h3>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-12 col-12">
//               <div>
//                 <input
//                   className="form-control borderRadius24"
//                   placeholder="Search"
//                   onChange={(e) =>
//                     setPayload({ ...payload, searchKey: e.target.value })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="col-lg-2 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, status: e.target.value })
//                   }
//                 >
//                   <option value="">Select Status</option>
//                   <option value={true}>Active</option>
//                   <option value={false}>Inactive</option>
//                 </select>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <div>
//                 <button
//                   className="btn w-100 borderRadius24 text-light"
//                   style={{ background: "#c34b36" }}
//                   onClick={() => navigate("/add-combo-product")}
//                 >
//                   Add Combo Pack
//                 </button>
//               </div>
//             </div>
//             <div className="col-lg-2 mb-2 col-md-6 col-12 dropdown">
//               <button
//                 className="btn w-100 borderRadius24 text-light p-2 dropdown-toggle"
//                 style={{ background: "#227C9D" }}
//                 type="button"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//               >
//                 Download
//               </button>
//               <ul className="dropdown-menu w-100">
//                 <li>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleDownload("pdf")}
//                   >
//                     Download as PDF
//                   </button>
//                 </li>
//               </ul>
//             </div>
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "30px 0px 0px 30px" }}
//                       >
//                         Sr. No
//                       </th>
//                       <th className="text-center py-3">Name</th>
//                       <th className="text-center py-3">Image</th>

//                       {/* <th className="text-center py-3">Combo Price</th> */}
//                       <th className="text-center py-3">Product</th>
//                       <th className="text-center py-3">Price</th>
//                       <th className="text-center py-3">Stock</th>
//                       <th className="text-center py-3">Status</th>

//                       <th
//                         className="text-center py-3 "
//                         style={{ borderRadius: "0px 30px 30px 0px" }}
//                       >
//                         Action
//                       </th>
//                     </tr>
//                     <div className="py-2"></div>
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((v, i) => {
//                           return (
//                             <>
//                               <tr key={i}>
//                                 <td className="text-center">
//                                   <Skeleton width={50} height={50} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton
//                                     width={50}
//                                     height={50}
//                                     borderRadius={25}
//                                   />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })
//                       : list?.map((v, i) => {
//                           return (
//                             <>
//                               <tr>
//                                 <td className="text-center">
//                                   {(payload.pageNo - 1) * payload.pageCount +
//                                     i +
//                                     1}
//                                 </td>

//                                 <td className="font-weight-600 text-center">
//                                   {v?.name}
//                                 </td>
//                                 <td className="text-center">
//                                   <img
//                                     src={v?.productHeroImage}
//                                     style={{ height: "30px" }}
//                                   />
//                                 </td>

//                                 {/* <td className="text-center">
//                                   {v?.pricing?.comboPrice}
//                                 </td> */}
//                                 <td className="text-center">
//                                   {Array.isArray(v?.productId) &&
//                                   v.productId.length > 0 ? (
//                                     <ul className="list-unstyled mb-0 text-start d-inline-block">
//                                       {v.productId.map((prodObj, idx) => (
//                                         <li
//                                           key={idx}
//                                           className="mb-1 px-2 py-1 bg-light rounded text-dark"
//                                         >
//                                           {prodObj?.product?.name} (
//                                           {prodObj?.quantity})
//                                         </li>
//                                       ))}
//                                     </ul>
//                                   ) : (
//                                     "-"
//                                   )}
//                                 </td>

//                                 <td className="text-center">
//                                   {v?.pricing?.offerPrice ? (
//                                     <div style={{ lineHeight: "1.2" }}>
//                                       <div
//                                         style={{
//                                           fontWeight: "bold",
//                                           fontSize: "16px",
//                                           color: "#28a745",
//                                         }}
//                                       >
//                                         {v?.pricing?.comboPrice}
//                                       </div>
//                                       <div
//                                         style={{
//                                           textDecoration: "line-through",
//                                           color: "#888",
//                                           fontSize: "13px",
//                                           marginTop: "4px",
//                                         }}
//                                       >
//                                         {v?.pricing?.currency}{" "}
//                                         {v?.pricing?.offerPrice}
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     <div
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "16px",
//                                       }}
//                                     >
//                                       {v?.pricing?.currency}{" "}
//                                       {v?.pricing?.actualPrice}
//                                     </div>
//                                   )}
//                                 </td>

//                                 <td className="text-center">
//                                   {v?.stockQuantity}
//                                 </td>
//                                 <td className="text-center">
//                                   {v?.status ? (
//                                     <div
//                                       className="badge py-2"
//                                       style={{
//                                         background: "#63ED7A",
//                                         cursor: "pointer",
//                                       }}
//                                       onClick={() =>
//                                         setEditFormData({
//                                           name: v?.name,
//                                           productHeroImage: v?.productHeroImage,
//                                           status: true,
//                                           _id: v?._id,
//                                         })
//                                       }
//                                     >
//                                       Active
//                                     </div>
//                                   ) : (
//                                     <div
//                                       className="badge py-2 "
//                                       style={{
//                                         background: "#FFA426",
//                                         cursor: "pointer",
//                                       }}
//                                       onClick={() =>
//                                         setEditFormData({
//                                           name: v?.name,
//                                           productHeroImage: v?.productHeroImage,
//                                           status: false,
//                                           _id: v?._id,
//                                         })
//                                       }
//                                     >
//                                       Inactive
//                                     </div>
//                                   )}
//                                 </td>

//                                 <td className="text-center">
//                                   <a
//                                     className="btn btn-info mx-2 text-light shadow-sm"
//                                     onClick={() =>
//                                       navigate(
//                                         "/update-combo-product-step1/" + v?._id
//                                       )
//                                     }
//                                   >
//                                     Edit
//                                   </a>
//                                   <a
//                                     className="btn btn-warning mx-2 text-light shadow-sm"
//                                     onClick={() =>
//                                       handleDeleteComboProductFunc(v?._id)
//                                     }
//                                   >
//                                     Delete
//                                   </a>
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })}
//                   </tbody>
//                 </table>

//                 <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-5 px-3 py-3 mt-4">
//                   <div className="d-flex align-items-center gap-2">
//                     <span className="fw-semibold text-secondary">Show</span>
//                     <select
//                       className="form-select form-select-sm custom-select"
//                       value={payload.pageCount}
//                       onChange={(e) =>
//                         setPayload({
//                           ...payload,
//                           pageCount: parseInt(e.target.value),
//                           pageNo: 1,
//                         })
//                       }
//                     >
//                       {[10, 25, 50, 100].map((v) => (
//                         <option key={v} value={v}>
//                           {v}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <nav>
//                     <ul className="pagination pagination-sm mb-0 custom-pagination">
//                       <li
//                         className={`page-item ${
//                           payload.pageNo === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo - 1)}
//                         >
//                           &lt;
//                         </button>
//                       </li>

//                       {[...Array(totalPages)].map((_, i) => {
//                         const page = i + 1;
//                         if (
//                           page === 1 ||
//                           page === totalPages ||
//                           (page >= payload.pageNo - 1 &&
//                             page <= payload.pageNo + 1)
//                         ) {
//                           return (
//                             <li
//                               key={page}
//                               className={`page-item ${
//                                 payload.pageNo === page ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => handlePageChange(page)}
//                               >
//                                 {page}
//                               </button>
//                             </li>
//                           );
//                         } else if (
//                           (page === payload.pageNo - 2 && page > 2) ||
//                           (page === payload.pageNo + 2 && page < totalPages - 1)
//                         ) {
//                           return (
//                             <li key={page} className="page-item disabled">
//                               <span className="page-link">...</span>
//                             </li>
//                           );
//                         }
//                         return null;
//                       })}

//                       <li
//                         className={`page-item ${
//                           payload.pageNo === totalPages ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo + 1)}
//                         >
//                           &gt;
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>

//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {editFormData?._id && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setEditFormData({
//                       _id: "",
//                       name: "",
//                       productHeroImage: "",
//                       status: "",
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Update Status</h5>
//                     <div className="p-3 border rounded mb-2">
//                       <img
//                         src={editFormData?.productHeroImage}
//                         className="img-fluid w-100 shadow rounded"
//                         style={{ height: "200px" }}
//                       />
//                     </div>

//                     <label className="mt-3">Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       readOnly
//                       value={editFormData?.name}
//                     />
//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           status: e?.target?.value,
//                         })
//                       }
//                       value={editFormData?.status}
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>

//                     {editFormData?.status ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && updateComboProductFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {editFormData?._id && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }

// export default ComboProductList;


import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../../Components/NoRecordFound";
import { useNavigate } from "react-router-dom";
import {
  deleteComboProductServ,
  exportComboProductServ,
  getComboProductServ,
  updateComboProductServ,
} from "../../../services/comboProduct.services";
import { triggerFileDownload } from "../../../utils/fileDownload";
import { IMAGE_BASE_URL } from "../../../utils/api_base_url_configration";


/* ─── Scoped styles — same design language as OrderList / ProductList ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap');

  .cp-root {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
  }

  /* ── Stat grid ── */
  .cp-stat-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 22px;
  }
  @media (max-width: 900px)  { .cp-stat-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 560px)  { .cp-stat-grid { grid-template-columns: 1fr; } }

  .cp-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .cp-stat-icon {
    width: 46px; height: 46px;
    border-radius: 12px;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 22px;
    color: #a60808;
    flex-shrink: 0;
  }
  .cp-stat-val {
    font-size: 26px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
    font-family: 'JetBrains Mono', monospace;
  }
  .cp-stat-lbl {
    font-size: 14px;
    color: #828282;
    margin-top: 5px;
    font-weight: 500;
  }

  /* ── Toolbar ── */
  .cp-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 18px 22px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .cp-toolbar-title {
    font-size: 20px;
    font-weight: 700;
    color: #1c0a0a;
    margin-right: auto;
  }

  .cp-input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #444;
    background: #f9f9f9;
    outline: none;
    min-width: 180px;
    font-family: 'DM Sans', sans-serif;
  }
  .cp-input:focus { border-color: #f0c0b8; }
  .cp-input::placeholder { color: #bbb; }

  .cp-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .cp-select:focus { border-color: #f0c0b8; }

  /* buttons */
  .cp-btn {
    height: 40px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 7px;
    white-space: nowrap;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .cp-btn-red  { background: #a60808; color: #fff; }
  .cp-btn-red:hover  { background: #a93226; }
  .cp-btn-blue { background: #2980b9; color: #fff; }
  .cp-btn-blue:hover { background: #2471a3; }

  /* download dropdown */
  .cp-download-wrap { position: relative; }
  .cp-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #f0eded;
    border-radius: 10px;
    padding: 6px;
    z-index: 200;
    min-width: 190px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.09);
  }
  .cp-dropdown-item {
    display: block; width: 100%;
    padding: 9px 14px;
    font-size: 14px;
    color: #444; background: none; border: none;
    border-radius: 7px; text-align: left; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .cp-dropdown-item:hover { background: #fdf2f1; color: #a60808; }

  /* ── Table card ── */
  .cp-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .cp-table-scroll { overflow-x: auto; }
  .cp-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  .cp-table thead tr { background: #fdf2f1; }
  .cp-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .cp-table th.center,
  .cp-table td.center { text-align: center; }
  .cp-table td {
    padding: 14px 16px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 15px;
  }
  .cp-table tbody tr:hover td { background: #fdfafa; }

  /* sr */
  .cp-sr { font-size: 13px; color: #bbb; font-family: 'JetBrains Mono', monospace; }

  /* combo cell */
  .cp-prod-cell { display: flex; align-items: center; gap: 12px; }
  .cp-prod-img {
    width: 50px; height: 50px;
    border-radius: 10px;
    object-fit: cover;
    border: 1px solid #f0eded;
    background: #fdf2f1;
    flex-shrink: 0;
  }
  .cp-prod-name {
    font-size: 15px; font-weight: 600; color: #1c0a0a;
    max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }

  /* included products */
  .cp-included-list { list-style: none; padding: 0; margin: 0; }
  .cp-included-item {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 12.5px; color: #555;
    background: #f9f9f9;
    border: 1px solid #f0eded;
    border-radius: 6px;
    padding: 3px 9px;
    margin: 2px 3px 2px 0;
    white-space: nowrap;
  }
  .cp-included-qty {
    font-size: 11px; font-weight: 700;
    color: #a60808;
    background: #fdf2f1;
    border-radius: 4px;
    padding: 1px 5px;
    font-family: 'JetBrains Mono', monospace;
  }

  /* price */
  .cp-price-main {
    font-size: 16px; font-weight: 700; color: #1c0a0a;
    font-family: 'JetBrains Mono', monospace;
  }
  .cp-price-strike {
    font-size: 13px; color: #bbb;
    text-decoration: line-through;
    font-family: 'JetBrains Mono', monospace;
    margin-top: 2px;
  }

  /* stock */
  .cp-stock {
    font-size: 15px; font-weight: 600;
    font-family: 'JetBrains Mono', monospace;
    color: #1c0a0a;
  }

  /* status badge */
  .cp-badge {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 12.5px; font-weight: 700;
    padding: 4px 12px; border-radius: 20px;
    cursor: pointer; transition: opacity 0.15s;
  }
  .cp-badge:hover { opacity: 0.8; }
  .cp-badge.active   { background: #e8f8ef; color: #27ae60; border: 1px solid #b7e4c7; }
  .cp-badge.inactive { background: #fff5e6; color: #e67e22; border: 1px solid #fcd9a0; }

  /* action buttons */
  .cp-edit-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
    margin-right: 6px;
  }
  .cp-edit-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }

  .cp-del-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #fcd9a0; background: #fff5e6;
    font-size: 14px; color: #e67e22;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .cp-del-btn:hover { background: #fdecea; border-color: #f0c0b8; color: #a60808; }

  /* skeleton */
  .cp-skel-cell { padding: 14px 16px; border-top: 1px solid #f7f5f5; }

  /* pagination */
  .cp-pagination {
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 12px;
    padding: 16px 22px;
    border-top: 1px solid #f7f5f5;
  }
  .cp-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }
  .cp-page-btns { display: flex; align-items: center; gap: 5px; }
  .cp-pg-btn {
    width: 36px; height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .cp-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .cp-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .cp-pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* ── Modal ── */
  .cp-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(28,10,10,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
  }
  .cp-modal {
    background: #fff;
    border-radius: 18px;
    width: 400px;
    max-width: 95vw;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.18);
    font-family: 'DM Sans', sans-serif;
  }
  .cp-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0eded;
  }
  .cp-modal-title { font-size: 17px; font-weight: 700; color: #1c0a0a; }
  .cp-modal-close {
    width: 32px; height: 32px;
    border-radius: 8px; border: 1px solid #f0eded;
    background: #f9f9f9; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #888; font-size: 16px; transition: all 0.15s;
  }
  .cp-modal-close:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }
  .cp-modal-body { padding: 22px 24px; }
  .cp-modal-footer {
    padding: 16px 24px; border-top: 1px solid #f0eded;
    display: flex; justify-content: flex-end; gap: 10px;
  }

  .cp-field-label {
    font-size: 12px; font-weight: 700; color: #888;
    text-transform: uppercase; letter-spacing: 0.5px;
    margin-bottom: 6px; display: block;
  }
  .cp-field-input {
    width: 100%;
    height: 42px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 15px;
    color: #1c0a0a;
    background: #f9f9f9;
    outline: none;
    font-family: 'DM Sans', sans-serif;
    margin-bottom: 14px;
  }
  .cp-field-input:focus { border-color: #f0c0b8; }
  .cp-field-input[readonly] { color: #999; }

  .cp-preview-img {
    width: 100%; height: 180px;
    object-fit: contain;
    border-radius: 10px;
    border: 1px solid #f0eded;
    background: #f9f9f9;
    margin-bottom: 16px;
  }
`;

function ComboProductList() {

    const getImageUrl = (image) => {
    if (!image) return "";
    if (image.startsWith("http")) return image;
    return `${IMAGE_BASE_URL}${image}`;
  };

  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [payload, setPayload] = useState({
    searchKey: "", status: "", pageNo: 1, pageCount: 10, sortByField: "",
  });
  const [showSkelton, setShowSkelton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editFormData, setEditFormData] = useState({
    name: "", productHeroImage: "", status: "", _id: "",
  });
  const [totalPages, setTotalPages] = useState(1);

  const handleGetComboProductFunc = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getComboProductServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  useEffect(() => { handleGetComboProductFunc(); }, [payload]);

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) setPayload({ ...payload, pageNo: newPage });
  };

  const updateComboProductFunc = async () => {
    try {
      let response = await updateComboProductServ({ id: editFormData?._id, status: editFormData?.status });
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" });
        handleGetComboProductFunc();
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  const handleDeleteComboProductFunc = async (id) => {
    if (window.confirm("Are you sure you want to delete this combo pack?")) {
      try {
        let response = await deleteComboProductServ(id);
        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          handleGetComboProductFunc();
        }
      } catch (error) {
        toast.error("Internal Server Error");
      }
    }
  };

  const handleDownload = async (format) => {
    setShowDownloadMenu(false);
    try {
      const response = await exportComboProductServ(payload);
      const ext = format === "excel" ? "xlsx" : format || "pdf";
      triggerFileDownload(response.data, `comboList.${ext}`);
    } catch (err) {
      toast.error("Download failed");
    }
  };

  const staticsArr = [
    { title: "Total Combo Packs",    count: statics?.totalCount,    icon: "🎁" },
    { title: "Active Combo Packs",   count: statics?.activeCount,   icon: "✅" },
    { title: "Inactive Combo Packs", count: statics?.inactiveCount, icon: "⏸️" },
  ];

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Product Management" selectedItem="Combo Packs" />
      <div className="mainContainer">
        <TopNav pageTitle="Combo Packs" pagePath="Home / Product Management / Combo Packs" />
        <div className="cp-root">

          {/* ── Stat Cards ── */}
          <div className="cp-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="cp-stat-card" key={i}>
                <div className="cp-stat-icon">{v.icon}</div>
                <div>
                  <div className="cp-stat-val">{v.count ?? "—"}</div>
                  <div className="cp-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="cp-toolbar">
            <div className="cp-toolbar-title">Combo Packs</div>

            <input
              className="cp-input"
              placeholder="🔍  Search combo packs..."
              onChange={(e) => setPayload({ ...payload, searchKey: e.target.value })}
            />

            <select className="cp-select" onChange={(e) => setPayload({ ...payload, status: e.target.value })}>
              <option value="">All Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>

            <button className="cp-btn cp-btn-red" onClick={() => navigate("/add-combo-product")}>
              <i className="ti ti-plus" /> Add Combo Pack
            </button>

            <div className="cp-download-wrap">
              <button className="cp-btn cp-btn-blue" onClick={() => setShowDownloadMenu((p) => !p)}>
                <i className="ti ti-download" /> Download
              </button>
              {showDownloadMenu && (
                <div className="cp-dropdown-menu">
                  <button className="cp-dropdown-item" onClick={() => handleDownload("pdf")}>
                    Download as PDF
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* ── Table ── */}
          <div className="cp-table-wrap">
            <div className="cp-table-scroll">
              <table className="cp-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Combo Pack</th>
                    <th>Included Products</th>
                    <th>Price</th>
                    <th className="center">Stock</th>
                    <th className="center">Status</th>
                    <th className="center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(7)].map((__, j) => (
                          <td key={j} className="cp-skel-cell"><Skeleton height={20} /></td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center", padding: "50px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v._id}>
                        {/* Sr */}
                        <td>
                          <span className="cp-sr">
                            {(payload.pageNo - 1) * payload.pageCount + i + 1}
                          </span>
                        </td>

                        {/* Combo Pack name + image */}
                        <td>
                          <div className="cp-prod-cell">
                               <img src={getImageUrl(v?.productHeroImage)} alt="" className="cp-prod-img" />
                            <div className="cp-prod-name">{v?.name}</div>
                          </div>
                        </td>

                        {/* Included Products */}
                        <td>
                          {Array.isArray(v?.productId) && v.productId.length > 0 ? (
                            <ul className="cp-included-list">
                              {v.productId.map((prodObj, idx) => (
                                <li key={idx} className="cp-included-item">
                                  {prodObj?.product?.name}
                                  <span className="cp-included-qty">×{prodObj?.quantity}</span>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <span style={{ color: "#bbb", fontSize: 14 }}>—</span>
                          )}
                        </td>

                        {/* Price */}
                        <td>
                          <div className="cp-price-main">
                            {v?.pricing?.currency} {v?.pricing?.comboPrice ?? v?.pricing?.actualPrice ?? "—"}
                          </div>
                          {v?.pricing?.offerPrice && (
                            <div className="cp-price-strike">
                              {v?.pricing?.currency} {v?.pricing?.offerPrice}
                            </div>
                          )}
                        </td>

                        {/* Stock */}
                        <td className="center">
                          <span className="cp-stock">{v?.stockQuantity ?? "—"}</span>
                        </td>

                        {/* Status */}
                        <td className="center">
                          {v?.status ? (
                            <span
                              className="cp-badge active"
                              onClick={() => setEditFormData({ name: v?.name, productHeroImage: v?.productHeroImage, status: true, _id: v?._id })}
                            >
                              <i className="ti ti-circle-check" style={{ fontSize: 13 }} /> Active
                            </span>
                          ) : (
                            <span
                              className="cp-badge inactive"
                              onClick={() => setEditFormData({ name: v?.name, productHeroImage: v?.productHeroImage, status: false, _id: v?._id })}
                            >
                              <i className="ti ti-circle-x" style={{ fontSize: 13 }} /> Inactive
                            </span>
                          )}
                        </td>

                        {/* Action */}
                        <td className="center" style={{ whiteSpace: "nowrap" }}>
                          <button
                            className="cp-edit-btn"
                            onClick={() => navigate("/update-combo-product-step1/" + v?._id)}
                          >
                            <i className="ti ti-pencil" /> Edit
                          </button>
                          <button
                            className="cp-del-btn"
                            onClick={() => handleDeleteComboProductFunc(v?._id)}
                          >
                            <i className="ti ti-trash" /> Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="cp-pagination">
              <div className="cp-show-row">
                Show
                <select
                  className="cp-select"
                  style={{ height: "34px", padding: "0 10px", minWidth: "unset" }}
                  value={payload.pageCount}
                  onChange={(e) => setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })}
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="cp-page-btns">
                <button className="cp-pg-btn" disabled={payload.pageNo === 1} onClick={() => handlePageChange(payload.pageNo - 1)}>
                  <i className="ti ti-chevron-left" style={{ fontSize: 14 }} />
                </button>
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (page === 1 || page === totalPages || (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)) {
                    return (
                      <button key={page} className={`cp-pg-btn ${payload.pageNo === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
                        {page}
                      </button>
                    );
                  } else if ((page === payload.pageNo - 2 && page > 2) || (page === payload.pageNo + 2 && page < totalPages - 1)) {
                    return <button key={page} className="cp-pg-btn" disabled>…</button>;
                  }
                  return null;
                })}
                <button className="cp-pg-btn" disabled={payload.pageNo === totalPages} onClick={() => handlePageChange(payload.pageNo + 1)}>
                  <i className="ti ti-chevron-right" style={{ fontSize: 14 }} />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Edit Status Modal ── */}
      {editFormData?._id && (
        <div className="cp-modal-overlay" onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}>
          <div className="cp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cp-modal-header">
              <div className="cp-modal-title">Update Combo Status</div>
              <button
                className="cp-modal-close"
                onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="cp-modal-body">
           <img src={getImageUrl(editFormData?.productHeroImage)} alt="" className="cp-preview-img" />
              <label className="cp-field-label">Combo Name</label>
              <input className="cp-field-input" readOnly value={editFormData?.name} />
              <label className="cp-field-label">Status</label>
              <select
                className="cp-field-input"
                style={{ cursor: "pointer" }}
                value={editFormData?.status}
                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
              >
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>
            </div>
            <div className="cp-modal-footer">
              <button
                className="cp-btn"
                style={{ background: "#f0eded", color: "#555" }}
                onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}
              >
                Cancel
              </button>
              <button
                className="cp-btn cp-btn-red"
                disabled={!editFormData?.status || isLoading}
                style={{ opacity: !editFormData?.status ? 0.5 : 1 }}
                onClick={!isLoading ? updateComboProductFunc : undefined}
              >
                {isLoading ? "Saving…" : "Update Status"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ComboProductList;